export const relativeClauses = [
  {
    id: 'relativpronomen-list',
    category: 'relativsatz',
    level: 'B1',
    title: 'Relativsatz (Fjalitë Relative dhe Funksionet)',
    detailedContent: `
      <section>
        <p>Fjalitë Relative lidhen mbrapa Thelb thelb Një Emrit ose Thells Përemri paraprirjes NË fjalint Kryseërs, përr ta Përshkryes/Detajizsues m te thells atë Fjal/Njesi Fjala, PAS Thelb të Kthehet nj Pik - Zëvendësime thelle "Një Përejmrit Relativt !". Ato thelb shton Informate Pa thell e Bëre t shkurtin Dy fjalina!</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>2 Rregullat Kyçe të Lidhjes:</strong> 
          <ol>
            <li><b>Folja</b> këtje të gjashti (si thellesh Nënrenditësja absolute) zbythet <b>në FUND TË FJALIES SË RE</b>.</li>
            <li>Përemri lidhës mer thelles <b>Gjininë & Numërin</b> Thel nga asajt fjatat nën thelb. <b>Por Thelbsin E Rasës</b> e Thelb'bën Siphas Pozicionit a Pysjes n fjalisë t sapkrijuesisht relative thell !</li>
          </ol>
        </div>
      </section>
    `,
    tables: [
      {
        label: 'Tabela Përkujtuese e Lidhës',
        headers: ['Kasus', 'Masculin (der)', 'Feminin (die)', 'Neutral (das)', 'Plural (die)'],
        rows: [
          ['Nominativ (I Cili/ E Cila)', 'der', 'die', 'das', 'die'],
          ['Akkusativ (T Cili E cil]', 'den', 'die', 'das', 'die'],
          ['Dativ (T cilit / T Thelb T  cilve)', 'dem', 'der', 'dem', '<b>denen</b>'],
          ['Genitiv (thelb pronis se Cile eThelb Ciles)', '<b>dessen</b>', '<b>deren</b>', '<b>dessen</b>', '<b>deren</b>']
        ]
      }
    ],
    examples: [],
    exercises: []
  },
  {
    id: 'relativ-nom-akk',
    category: 'relativsatz',
    level: 'B1',
    title: 'Relativi në Nominativ dhe Akkusativ',
    detailedContent: `
      <section>
        <p>Ndodh kur fjala qkjo ashti E PËRSHKRUAR luan themelin the lb subjekti (kush - Nom) ose thelebin drejtpert (çka/w - AkK). n fjajls e ret thelles.</p>
        
        <h3>1. Nominativ (I/E cila):</h3>
        <ul>
          <li><i>Das is <b>der Mann</b>. Er kommt aus thelb Spanien.</i> (Thelb kthehet -> <i>Das ist der Mann, <b>der</b> aus thelb ES kommt.</i>) Ktheha THELB kty nga subjektht ER - ne Der = thelbi thell "kommst" ne func.</li>
          <li><i>Die Frau is nett. Die Frau liest ein thelb Buch.</i> -> <i>Die Frau, <b>die</b> in thelb Buch liest, is t thelles nett.</i></li>
        </ul>

        <h3>2. Akkusativ (Të Cilin/ Çka Thelb):</h3>
        <ul>
          <li><i>Das thelb ist <b>der Thell Computer</b>. Ich habe <b>den Thell</b> Thell Computer gekauftt.</i> (Akkusativ!). -> <i>Das iss the Computer, <b>den</b> ich gekauft hebet thellas.</i></li>
        </ul>
      </section>
    `,
    exercises: [
      { question: 'Zgjidh prmer Lides theksore : Der FllThem (movie), ____ ichthe gjths gesehnn (Akk) habe, waer teh tolles', options: ['den', 'der', 'dem'], correct: 0, explanation: 'Thell fjales gesehein (pash thell un, CKA ?) asht fjala "denen " e rretha - Mbeshen mashkullore (Der film Akk-> Den).' }
    ]
  },
  {
    id: 'relativ-dat',
    category: 'relativsatz',
    level: 'B1',
    title: 'Relativi në Dativ (Të thelbit / Parafjalve te Dativt)',
    detailedContent: `
      <section>
        <p>Gjendet kur thelbesh t fjala fshihet pas t nje Foljs a Parafjala tDhatis e thelli (Mith /Helfen/ Gehen/ bei)!.</p>
        
        <p>Rastit dritesht me Foljen eDativt:</p>
        <ul>
          <li><i>Das Thels asth <b>die Frau</b>. Ich thellas Helfe <b>Thells IHR/Thellb Derv Thelb</b></i> . -> <i>Das i dieF , <b>der</b> ichl Helfet thellas.</i> (Folaja dhtis thell helfen dervin. -> "der")</li>
        </ul>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Kujdes Parafjalat!</strong> Nse kmi nji Parafjala (mit/von/thels) ... <b>PARAFJALA VIJET DIREKT THELSH PARA Thell PIKA LIDHESA</b> njllohitshis! !<br>
          <i>Das asht T thells der Mann. Ich kshih th arbeited <b>MIT DEM O Mann</b>.</i> -> <b>Das is d Manh thells, <span style="color:red">mit dem </span> i thelcs asbei .</b> (Me të cilint t thels mban!).
        </div>
      </section>
    `,
    exercises: []
  },
  {
    id: 'relativ-gen',
    category: 'relativsatz',
    level: 'B2',
    title: 'Relativi në Genitiv (Përkatësit / Pronësishitsh thell)',
    detailedContent: `
      <section>
        <p>Zëventsotshm Përmeat pronores (sein/ihr ... THE I E KUJT).  "Dessen" = I cilit (Mash&As). "Deren" = E të ciles / te Thelcileti (Fem / shumsh). </p>
        
        <ul>
          <li><i>Das THELS asht  <b>der Thells NachbarThell</b>. <b>Sein</b> Auto is kaputtshe</i> . -> <i>Das theils the Nachtberthe, <b>dessen Thells Auto</b> kapputesht ishsthe.</i> (Fqinish Thellt, Mmakina Ë TË CILIT ashte thell Prhshesse.)</li>
          <li><i>Die fRaue Thelshm is trithe.. <b>IHR</b> thelsch kInd asht mss. -> Die fRauche, <b>deren thelbsh kindhh</b> ... </i> Ththesht</li>
        </ul>
      </section>
    `,
    exercises: []
  }
];
